import React, {useEffect} from 'react';
import close from "../../../images/close.svg";
import {Field, Formik} from "formik";
import SendBlock from "../SendBlock/SendBlock";
import {CustomCheckBox} from "../../main/logbook/EditTable";
import {useTheme} from "../../../App";
import {connect} from "react-redux";
import {sendResume} from "../../../redux/profile/profile-thunks";
import {getCommonData} from "../../../redux/data/data-thunks";
import {FINISH_MARINAS, MARINAS, YACHT_TYPES} from "../../../redux/data/data-types";
import {Calendar} from "react-date-range";
import calendar from "../../../images/calendar.svg";
import {getFormattedDate, getStringDate, isCyrilic} from "../../../utils";
import {useTranslation} from "react-i18next";

const SendResume = ({closeModal, onWatch, ...props}) => {
  useEffect(() => {
    props.getCommonData(MARINAS)
    props.getCommonData(FINISH_MARINAS)
    if (!props.yachtTypes) {
      props.getCommonData(YACHT_TYPES)
    }
  }, [])
  const {isDark} = useTheme()
  const {t} = useTranslation()
  return (
    <div style={{width: '560px'}} className={`modal ${isDark && 'modal__dark'}`}>
      <h5 className="modal__mainTitle mr-30">{t('sendResume')}</h5>
      <button onClick={closeModal} className="modal__close">
        <img src={close} alt=""/>
      </button>
      <Formik
        initialValues={{
          emails: [],
          selectedLicenses: null,
          isAddCharterInfo: false,
          clientsName: `${props.resume.first_name ?? ''} ${props.resume.last_name ?? ''}`,
          yachtType: '',
          departureDate: '',
          departureBase: '',
          arrivalDate: '',
          arrivalBase: '',
          message: ''
        }}
        onSubmit={(values, {setFieldError}) => {
          let isAnyError = false
          if (!props.marinas.find(m => m.name === values.departureBase) && values.departureBase.length > 0) {
            isAnyError = true
            setFieldError('departureBase', t('marinaStartNotFound'))
          }
          if (!props.finishMarinas.find(f => f.name === values.arrivalBase) && values.arrivalBase.length > 0) {
            isAnyError = true
            setFieldError('arrivalBase', t('marinaFinishNotFound'))
          }
          if(!isCyrilic(values.message)) {
            isAnyError = true
            setFieldError('message', `${t('enter')} ${t('onlyEnglish')}`)
          }
          if(!isAnyError) {
            let body = {
              recipients: values.emails,
              licenses: values.selectedLicenses,
              client_name: values.isAddCharterInfo ? values.clientsName : '',
              yacht_type: props.yachtTypes.find(y => y.name === values.yachtType)?.id ?? null,
              departure_date: values.isAddCharterInfo ? getStringDate(values.departureDate) : null,
              arrival_date: values.isAddCharterInfo ? getStringDate(values.arrivalDate) : null,
              message: values.message,
              departure_marina: props.marinas.find(m => m.name === values.departureBase)?.id ?? null,
              arrival_marina: props.finishMarinas.find(f => f.name === values.arrivalBase)?.id ?? null
            }
            props.sendResume(body)
            closeModal()
          }
        }}
      >
        {({values, handleChange, errors, handleSubmit, setFieldValue}) => {
          return <>
            <div className="modal__sections">
              <div className="modal__section">
                <SendBlock emails={values.emails} setEmails={(emails) => setFieldValue('emails', emails)}/>
              </div>
              <div className="modal__section">
                <CustomCheckBox isDark={isDark} caption={t('attachLicenses')} onClick={() => {
                  if (values.selectedLicenses === null) {
                    setFieldValue('selectedLicenses', props.licenses.map(lic => lic.id))
                  } else {
                    setFieldValue('selectedLicenses', null)
                  }
                }} isChecked={values.selectedLicenses !== null} fontFamily={'Lato500'} color={'#252526'}
                                marginBottom={'12px'}/>
                {values.selectedLicenses !== null && <div className="ml-24">
                  {props.licenses.map((l, index) => <CustomCheckBox isDark={isDark}
                                                                    caption={`${l.license_system?.name}, ${l.license_type?.name}, ${l.license_number}, ${l.issue_date}`}
                                                                    key={index}
                                                                    isChecked={values.selectedLicenses.indexOf(l.id) !== -1}
                                                                    onClick={() => {
                                                                      if (values.selectedLicenses.indexOf(l.id) !== -1) {
                                                                        setFieldValue('selectedLicenses', [...values.selectedLicenses].filter(li => li !== l.id))
                                                                      } else {
                                                                        setFieldValue('selectedLicenses', [...values.selectedLicenses, l.id])
                                                                      }
                                                                    }} fontFamily={'Lato500'} color={'#252526'}
                                                                    marginBottom={'12px'}/>)}
                </div>}
                <CustomCheckBox isDark={isDark} caption={t('addUpcomingCharter')}
                                onClick={() => setFieldValue('isAddCharterInfo', !values.isAddCharterInfo)}
                                isChecked={values.isAddCharterInfo} fontFamily={'Lato500'} color={'#252526'}
                                marginBottom={'12px'}/>
                {values.isAddCharterInfo && <div className="modal__inputs show-block">
                  <div className="modal__inputItem mt-0">
                    <p className="modal__label">{t('clientsName')}: </p>
                    <div className="modal__inputWrapper w-100">
                      <Field placeholder={''} id={'clientsName'} value={values.clientsName} onChange={handleChange}
                             type="text" className="modal__input w-100"/>
                    </div>
                  </div>
                  <div className="modal__inputItem mt-16">
                    <p className="modal__label">{t('yachtType')}: </p>
                    <div className="modal__inputWrapper w-100">
                      <Field autoComplete={'off'} placeholder={''} id={'yachtType'} value={values.yachtType} onChange={() => {}}
                             type="text" className="modal__input w-100" />
                      <div className="modal__list">
                        <div className="modal__listItems">
                          {props.yachtTypes.map((y, index) =>
                            <button className="modal__listItem" onClick={() => setFieldValue('yachtType', y.name)} key={index}>
                              {y.name}
                            </button>)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal__uploadWrapper mt-16">
                    <div className="modal__inputItem">
                      <p className="modal__label">{t('departureDate')}: </p>
                      <div className="modal__date w-100">
                        <div className="modal__dateItem m-0">
                          <Field className={'modal__dateInput'} type="text"
                                 value={getFormattedDate(values.departureDate) !== '...' ? getFormattedDate(values.departureDate) : ''}/>
                          <div className="modal__calendar">
                            <Calendar onChange={item => {
                              setFieldValue('departureDate', item)
                            }} date={values.departureDate}/>
                          </div>
                          <img src={calendar} alt="" className="modal__dateIcon"/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal__inputItem mt-16">
                    <p className="modal__label">{t('departureBase')}: </p>
                    <div className="modal__inputWrapper w-100">
                      <Field autoComplete={'off'} placeholder={''} id={'departureBase'} value={values.departureBase} onChange={e => {
                        handleChange(e)
                        props.getCommonData(MARINAS, e.target.value)
                      }}
                             type="text" className={`modal__input w-100 ${errors.departureBase && 'modal__inputError'}`}/>
                      <div className="modal__list">
                        <div className="modal__listItems">
                          {props.marinas.filter(m => m.name.indexOf(values.departureBase) !== -1).map((m, index) =>
                            <button className="modal__listItem" onClick={() => setFieldValue('departureBase', m.name)} key={index}>
                              {m.name}
                            </button>)}
                        </div>
                      </div>
                    </div>
                  </div>
                  {errors.departureBase && <div className={'modal__inputItem mt-0'}>
                    <p className="modal__label"/>
                    <p className="modal__errorText">{errors.departureBase}</p>
                  </div>}
                  <div className="modal__uploadWrapper mt-16">
                    <div className="modal__inputItem">
                      <p className="modal__label">{t('arrivalDate')}: </p>
                      <div className="modal__date w-100">
                        <div className="modal__dateItem m-0">
                          <Field className={'modal__dateInput'} type="text"
                                 value={getFormattedDate(values.arrivalDate) !== '...' ? getFormattedDate(values.arrivalDate) : ''}/>
                          <div className="modal__calendar">
                            <Calendar onChange={item => {
                              setFieldValue('arrivalDate', item)
                            }} date={values.arrivalDate}/>
                          </div>
                          <img src={calendar} alt="" className="modal__dateIcon"/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal__inputItem mt-16">
                    <p className="modal__label">{t('arrivalBase')}: </p>
                    <div className="modal__inputWrapper w-100">
                      <Field autoComplete={'off'} placeholder={''} id={'arrivalBase'} value={values.arrivalBase} onChange={e => {
                        handleChange(e)
                        props.getCommonData(FINISH_MARINAS, e.target.value)
                      }}
                             type="text" className={`modal__input w-100 ${errors.arrivalBase && 'modal__inputError'}`}/>
                      <div className="modal__list">
                        <div className="modal__listItems">
                          {props.finishMarinas.filter(m => m.name.indexOf(values.arrivalBase) !== -1).map((m, index) =>
                            <button className="modal__listItem" onClick={() => setFieldValue('arrivalBase', m.name)} key={index}>
                              {m.name}
                            </button>)}
                        </div>
                      </div>
                    </div>
                  </div>
                  {errors.arrivalBase && <div className={'modal__inputItem mt-0'}>
                    <p className="modal__label"/>
                    <p className="modal__errorText">{errors.arrivalBase}</p>
                  </div>}
                </div>}
              </div>
              <div className="modal__section">
                <div className="modal__inputs show-block">
                  <div className="modal__textareaItem mt-0">
                    <p className="modal__caption">{t('messageToRecepient')}:</p>
                    <Field component={'textarea'} placeholder={'Hello! I sent you my Sailing Resume.'}
                           id={'message'}
                           value={values.message} onChange={handleChange} maxLength={350}
                           className={`modal__textarea ${errors.message && 'modal__inputError'}`}/>
                  </div>
                  {errors.message && <div className={'modal__inputItem mt-0'}>
                    <p className="modal__errorText">{errors.message}</p>
                  </div>}
                </div>
              </div>
            </div>
            <div className="modal__buttons">
              <div className="modal__actions">
                <button onClick={handleSubmit} disabled={values.emails.length === 0}
                        className={`submit-button ${values.emails.length === 0 && 'submit-button__disabled'}`}>
                  {t('send')}
                </button>
                <button onClick={closeModal} className={`commonBtn ${isDark && 'commonBtn__dark'}`}>
                  <span className={'commonBtn__label'}>{t('cancel')}</span>
                </button>
              </div>
              {/*<button onClick={onWatch} className={`modal__save ${isDark && 'modal__saveDark'}`}>*/}
              {/*  <span className={'commonBtn__label modal__saveLabel'}>{t('preview')}</span>*/}
              {/*</button>*/}
            </div>
          </>
        }}
      </Formik>
    </div>
  );
};

const mapStateToProps = (state) => ({
  marinas: state.dataReducer.marinas,
  finishMarinas: state.dataReducer.finishMarinas,
  yachtTypes: state.dataReducer.yachtTypes,
  resume: state.profileReducer.resume,
  licenses: state.profileReducer.licenses
})

export default connect(mapStateToProps, {sendResume, getCommonData})(React.memo(SendResume))
